/**
 * [AUDIO PROCTORING v2] Question context shared across hooks.
 *
 * Two roles:
 *  1. `getCurrentQuestion()` — the live question (module-level so the VAD hook, if
 *     client-side VAD is on, can read it without a stale closure).
 *  2. A question TIMELINE buffer — each QUESTION_CHANGED is recorded with its
 *     wall-clock `shownAt`, then drained onto the audio upload so SERVER-side VAD can
 *     attribute detected speech to the question on screen at that time (Option A).
 */
let current = { questionId: null, questionType: null, index: null };
let timeline = [];
let seq = 0;

export const setCurrentQuestion = ({ questionId = null, questionType = null, index = null } = {}) => {
    current = { questionId, questionType, index };
};

export const clearCurrentQuestion = () => {
    current = { questionId: null, questionType: null, index: null };
};

export const getCurrentQuestion = () => current;

// Record a question becoming active — updates the live value AND appends to the
// timeline buffer that rides along with the next audio upload.
export const recordQuestionShown = ({ questionId = null, questionType = null, index = null } = {}) => {
    setCurrentQuestion({ questionId, questionType, index });
    timeline.push({
        questionId,
        questionType,
        questionIndex: index,
        shownAt: new Date().toISOString(),
        clientEventId: `qt-${Date.now()}-${seq++}`,
    });
};

// Return and clear the buffered question-timeline events (called at chunk upload).
export const drainQuestionEvents = () => {
    const out = timeline;
    timeline = [];
    return out;
};
